import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TuiCardLarge, tuiCardOptionsProvider } from '@taiga-ui/layout';

@Component({
  selector: 'pxc-card-details',
  templateUrl: './card-details.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [],
  hostDirectives: [TuiCardLarge],
  providers: [tuiCardOptionsProvider({ appearance: 'outline' })],
  host: {
    class: 'h-full px-6',
  },
})
export class CardDetailsComponent {}
